import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { SubmittalPacketsManagementDrawer } from './submittal-packets-management-drawer';
import { Button } from 'antd';
import { Icon } from '@common/components';

export function SubmittalPacketsManagementDrawerButton({ worksProfile }) {
  const [shouldShowDrawer, setShouldShowDrawer] = useState(false);

  return (
    <>
      <SubmittalPacketsManagementDrawer
        visible={shouldShowDrawer}
        onClose={() => {
          setShouldShowDrawer(false);
        }}
        selectedWorksProfile={worksProfile}
      />
      <Button
        onClick={() => {
          setShouldShowDrawer(true);
        }}
      >
        <Icon icon="copy" kind="regular" />
        &nbsp;Manage Submittal Packets
      </Button>
    </>
  );
}

SubmittalPacketsManagementDrawerButton.propTypes = {
  worksProfile: PropTypes.object,
};
